module.exports = __webpack_public_path__ + "img/Portugalska.5acddf6e.png";